import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/404_images/404.png';
import _imports_1 from '@/assets/404_images/404_cloud.png';
var _hoisted_1 = {
  class: "wscn-http404-container"
};
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: '404',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    function back() {
      if (route.query.noGoBack) {
        router.push({
          path: '/home'
        });
      } else {
        router.go(-1);
      }
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "wscn-http404"
      }, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"pic-404\" data-v-21cfa130><img class=\"pic-404__parent\" src=\"" + _imports_0 + "\" alt=\"404\" data-v-21cfa130><img class=\"pic-404__child left\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-21cfa130><img class=\"pic-404__child mid\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-21cfa130><img class=\"pic-404__child right\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-21cfa130></div>", 1)), _createElementVNode("div", {
        class: "bullshit"
      }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "bullshit__oops"
      }, "对不起！", -1)), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "bullshit__headline"
      }, "您访问的页面或资源不存在或者没有权限...", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "bullshit__info"
      }, "请检查地址栏中的URL是否输入正确，或联系系统管理员。", -1)), _createElementVNode("a", {
        onClick: back,
        class: "bullshit__return-home"
      }, "回到首页")])])]);
    };
  }
});